import { render } from "./DropdownArrowsIcon.vue?vue&type=template&id=0f9af6a8"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__